import { render, staticRenderFns } from "./CourseSessionHistory.vue?vue&type=template&id=227de5c3&"
import script from "./CourseSessionHistory.vue?vue&type=script&lang=ts&"
export * from "./CourseSessionHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports